/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type InviteErrorCode = 0 | 1 | 2 | 3;

export const InviteErrorCode = {
    NUMBER_0: 0 as InviteErrorCode,
    NUMBER_1: 1 as InviteErrorCode,
    NUMBER_2: 2 as InviteErrorCode,
    NUMBER_3: 3 as InviteErrorCode
}